import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { useSelector, useDispatch } from 'react-redux'
import i18n from "i18next";

import { setFormattedCatalogs, setCatalogCurrentSectionTree } from '@actions/catalogs';
import { getSectionTree } from '@actions/sections';

import { cleanStorageAuth } from '@utils/general'

import { LANGUAGE_DEFAULT, CURRENT_LENGUAGE } from '@constants/general'

import { locale } from 'primereact/api';

const AppProfile = ({setLanguageSelectedMain}) => {
  const [expanded, setExpanded] = useState(false);
  const [expandedLanguage, setExpandedLanguage] = useState(false);
  const [languageSelected, setLanguageSelected] = useState('');
  const [languageKeySelected, setLanguageKeySelected] = useState('');

  const dispatch = useDispatch();
  const itemsTabsLenguages = useSelector(state => state.catalogs.itemsLanguageCatalog);

  useEffect(() => {
    if (!localStorage.getItem(CURRENT_LENGUAGE)) localStorage.setItem(CURRENT_LENGUAGE, LANGUAGE_DEFAULT)
    const currentLanguage = localStorage.getItem(CURRENT_LENGUAGE)
    const getLanguage = itemsTabsLenguages.find(item => item.key === currentLanguage)
    setLanguageKeySelected(currentLanguage)
    setLanguageSelected(getLanguage.label)
  }, [])

  useEffect(() => {
    if (itemsTabsLenguages.length && languageKeySelected) {
      const getLanguage = itemsTabsLenguages.find(item => item.key === languageKeySelected)
      setLanguageSelected(getLanguage.label)
    }
  }, itemsTabsLenguages)

  const onClick = (event) => {
    setExpanded((prevState) => !prevState);
    event.preventDefault();
  };
  const onClickLanguage = (event) => {
    setExpandedLanguage((prevState) => !prevState);
    event.preventDefault();
  };

  const logout = async () => {
    await cleanStorageAuth()
    window.setValueToIframe("")
    return window.location = '/';
  };

  const onChangeLenguage = async (key) => {
    setLanguageKeySelected(key)
    setLanguageSelectedMain(key)
    i18n.changeLanguage(key);
    locale(key)
    await dispatch(setFormattedCatalogs());
    await dispatch(getSectionTree())
    await dispatch(setCatalogCurrentSectionTree())
    localStorage.setItem(CURRENT_LENGUAGE, key)
  }
  

  const renderLanguages = (
    itemsTabsLenguages.map(item => (
      <li key={`language-${item.key}`}>
        <button type="button" className="p-link" onClick={() => onChangeLenguage(item.key)}>
          <span>{item.label}</span>
        </button>
      </li>
    ))
  )

  const getName = JSON.parse(sessionStorage.getItem("user"))?.username || ''

  return (
    <div className="layout-profile">
      <button
        className="p-link layout-profile-link"
        type="button"
        onClick={onClick}
      >
        <span className="username">{getName}</span>
        <i className="pi pi-fw pi-cog" />
      </button>
      <CSSTransition
        classNames="p-toggleable-content"
        timeout={{ enter: 1000, exit: 450 }}
        in={expanded}
        unmountOnExit
      >
        <ul className={classNames({ 'layout-profile-expanded': expanded })}>
          <li>
            <button type="button" className="p-link" onClick={logout}>
              <i className="pi pi-fw pi-power-off" />
              <span>{i18n.t('Cerrar Sesión')}</span>
            </button>
          </li>
        </ul>
      </CSSTransition>
      <br/>
      <button
        className="p-link layout-profile-link"
        type="button"
        onClick={onClickLanguage}
      >
        <span className="username"><u>{languageSelected}</u></span>
        <i className="pi pi-globe" />
      </button>
      <CSSTransition
        classNames="p-toggleable-content"
        timeout={{ enter: 1000, exit: 450 }}
        in={expandedLanguage}
        unmountOnExit
      >
        <ul className={classNames({ 'layout-profile-expanded': expandedLanguage })}>
          { renderLanguages }
        </ul>
      </CSSTransition>
    </div>
  );
};

export default AppProfile;
